import { EditOutlined } from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import {
  CopilotHumanEditedSection,
  getSectionHumanEditedAt,
  isSectionHumanEdited,
} from "../utils/copilotExtensions";
import { useCopilotClinicalContext } from "../../useCopilotClinicalContext";

type CopilotSectionEditedBadgeProps = {
  section: CopilotHumanEditedSection;
};

const CopilotSectionEditedBadge = ({
  section,
}: CopilotSectionEditedBadgeProps) => {
  const { copilotData } = useCopilotClinicalContext();

  if (!isSectionHumanEdited(copilotData, section)) {
    return null;
  }

  const editedAt = getSectionHumanEditedAt(copilotData, section);
  const tooltip = editedAt
    ? `Clinician edited ${formatDistanceToNow(editedAt, { addSuffix: true })}`
    : "Clinician edited this section";

  return (
    <Tooltip title={tooltip}>
      <Chip
        icon={<EditOutlined sx={{ "&&": { fontSize: 14 } }} />}
        label="Edited"
        size="small"
        color="warning"
        variant="outlined"
        sx={{
          height: 22,
          "& .MuiChip-label": { px: 0.75, fontSize: "0.7rem" },
        }}
      />
    </Tooltip>
  );
};

export default CopilotSectionEditedBadge;
